import { render } from "./DashboardPage.vue?vue&type=template&id=558a6094"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__